import { normalize } from 'normalizr';

import { notify } from 'utils/reduxUtils';

import { processSchema } from './service';

export const types = {
  INIT: 'processes/listPage/INIT',
  NEW_PROCESS_MODAL_OPEN: 'processes/listPage/NEW_PROCESS_MODAL_OPEN',
  NEW_PROCESS_MODAL_CLOSE: 'processes/listPage/NEW_PROCESS_MODAL_CLOSE',
  CREATE_REQUEST: 'processes/listPage/CREATE_REQUEST',
  CREATE_SUCCESS: 'processes/listPage/CREATE_SUCCESS',
  CREATE_ERROR: 'processes/listPage/CREATE_ERROR',

  ACCOUNT_DOWNLOAD_ERROR: 'processes/listPage/ACCOUNT_DOWNLOAD_ERROR',
  ACCOUNT_DOWNLOAD_REQUEST: 'processes/listPage/ACCOUNT_DOWNLOAD_REQUEST',
  ACCOUNT_DOWNLOAD_SUCCESS: 'processes/listPage/ACCOUNT_DOWNLOAD_SUCCESS',

  ACCOUNT_DOWNLOAD_MODAL_CLOSE:
    'processes/listPage/ACCOUNT_DOWNLOAD_MODAL_CLOSE',
  ACCOUNT_DOWNLOAD_MODAL_OPEN: 'processes/listPage/ACCOUNT_DOWNLOAD_MODAL_OPEN',

  ACCOUNT_UPLOAD_ERROR: 'processes/listPage/ACCOUNT_UPLOAD_ERROR',
  ACCOUNT_UPLOAD_REQUEST: 'processes/listPage/ACCOUNT_UPLOAD_REQUEST',
  ACCOUNT_UPLOAD_SUCCESS: 'processes/listPage/ACCOUNT_UPLOAD_SUCCESS',

  ACCOUNT_UPLOAD_MODAL_CLOSE: 'processes/listPage/ACCOUNT_UPLOAD_MODAL_CLOSE',
  ACCOUNT_UPLOAD_MODAL_OPEN: 'processes/listPage/ACCOUNT_UPLOAD_MODAL_OPEN',

  ACCOUNT_VALIDATE_ERROR: 'processes/listPage/ACCOUNT_VALIDATE_ERROR',
  ACCOUNT_VALIDATE_REQUEST: 'processes/listPage/ACCOUNT_VALIDATE_REQUEST',
  ACCOUNT_VALIDATE_SUCCESS: 'processes/listPage/ACCOUNT_VALIDATE_SUCCESS',

  ACCOUNT_VALIDATE_MODAL_CLOSE:
    'processes/listPage/ACCOUNT_VALIDATE_MODAL_CLOSE',
  ACCOUNT_VALIDATE_MODAL_OPEN: 'processes/listPage/ACCOUNT_VALIDATE_MODAL_OPEN',
};

export const init = (data) => ({
  type: types.INIT,
  payload: normalize(data, [processSchema]),
});

export const createProcess = {
  request: (payload) => ({
    type: types.CREATE_REQUEST,
    payload,
  }),
  success: (payload) => ({
    type: types.CREATE_SUCCESS,
    payload: normalize(payload, processSchema),
  }),
  error: (error) => ({
    type: types.CREATE_ERROR,
    payload: error,
  }),
};

export const newProcessModal = {
  open: () => ({
    type: types.NEW_PROCESS_MODAL_OPEN,
  }),
  close: () => ({
    type: types.NEW_PROCESS_MODAL_CLOSE,
  }),
};

export const accountDownloadModal = {
  open: () => ({
    type: types.ACCOUNT_DOWNLOAD_MODAL_OPEN,
  }),
  close: () => ({
    type: types.ACCOUNT_DOWNLOAD_MODAL_CLOSE,
  }),
};

export const accountDownload = {
  error: notify(
    (error) => ({
      type: types.ACCOUNT_DOWNLOAD_ERROR,
      payload: error,
    }),
    'Failed to download account yaml',
  ),
  request: ({ criticalFieldsOnly, writeVariablesToCsv }) => ({
    type: types.ACCOUNT_DOWNLOAD_REQUEST,
    payload: { criticalFieldsOnly, writeVariablesToCsv },
  }),
  success: () => ({
    type: types.ACCOUNT_DOWNLOAD_SUCCESS,
  }),
};

export const accountUploadModal = {
  open: () => ({
    type: types.ACCOUNT_UPLOAD_MODAL_OPEN,
  }),
  close: () => ({
    type: types.ACCOUNT_UPLOAD_MODAL_CLOSE,
  }),
};

export const accountUpload = {
  error: () => ({
    type: types.ACCOUNT_UPLOAD_ERROR,
  }),
  request: (payload) => ({
    type: types.ACCOUNT_UPLOAD_REQUEST,
    payload: payload,
  }),
  success: notify(
    () => ({
      type: types.ACCOUNT_UPLOAD_SUCCESS,
    }),
    'Successfully imported account configuration',
  ),
};

export const accountValidateModal = {
  open: () => ({
    type: types.ACCOUNT_VALIDATE_MODAL_OPEN,
  }),
  close: () => ({
    type: types.ACCOUNT_VALIDATE_MODAL_CLOSE,
  }),
};

export const accountValidate = {
  error: () => ({
    type: types.ACCOUNT_VALIDATE_ERROR,
  }),
  request: (payload) => ({
    type: types.ACCOUNT_VALIDATE_REQUEST,
    payload: payload,
  }),
  success: notify(
    () => ({
      type: types.ACCOUNT_VALIDATE_SUCCESS,
    }),
    'Account configuration is valid',
  ),
};
